import React from "react";
import Hero from "components/hero";
import RichText from "components/rich-text";
import ImageBanner from "components/image-banner";
import ImageText from "components/image-text";
import USPS from "components/usps";
import StaticReviews from "components/static-reviews";
import ButtonsGrid from "components/buttons-grid";
import { verticalSpacing } from "utils/module-settings";
import FeaturedBlogs from "components/blog/featured-blogs";
import FeaturedCollection from "components/featured-collection";
import StoreReviews from "components/store-reviews";
import ContactForm from "components/contact-form";
import ProductFinder from "components/product-finder";
import CollectionDetails from "components/collection-details";
import VideoText from "components/video-text";
import Product from "components/product";
import CoversBookGuide from "components/covers-book-guide";
import VehicleStylesShowcase from "components/vehicle-styles-showcase";
import SmallRichText from "components/small-rich-text";
import CollectionSizeGuide from "components/collection-size-guide";
import GenericTable from "components/generic-table";
import GenericIframe from "components/generic-iframe";
import RichTextLP from "components/rich-text-lp";
import PatioLinks from "components/patio-links";
import TarpProductBlocks from "components/tarp-product-blocks";
import ImageGridWithHeader from "components/image-grid-wHeader";
import CustomHtmlCode from "components/custom-html-code";
import PatioBreadcrumbs from "components/patio-breadcrumbs";
import ProductCreator from "components/product-creator";
import ProductFindBySize from "components/product-find-by-size";
import Breadcrumbs from "@_modules/breadcrumbs";
import CategoryGrid from "@_modules/category-grid";
import Tabs from "@_modules/tabs";
import AccordionProductLayout from "@_modules/accordion-product-layout";
import CTA from "@_modules/cta";

const _module2Component = {
    hero: Hero,
    richText: RichText,
    imageBanner: ImageBanner,
    imageText: ImageText,
    usps: USPS,
    staticReviews: StaticReviews,
    featuredBlogs: FeaturedBlogs,
    buttonsGrid: ButtonsGrid,
    featuredCollection: FeaturedCollection,
    iframe: GenericIframe,
    storeReviews: StoreReviews,
    contactForm: ContactForm,
    productFinder: ProductFinder,
    collectionDetails: CollectionDetails,
    videoWithText: VideoText,
    productsData: Product,
    coversBookGuide: CoversBookGuide,
    vehicleStylesShowcase: VehicleStylesShowcase,
    collectionSizeGuide: CollectionSizeGuide,
    smallRichText: SmallRichText,
    genericTable: GenericTable,
    richTextLP: RichTextLP,
    patioLinks: PatioLinks,
    productBlocks: TarpProductBlocks,
    imageGridWithHeader: ImageGridWithHeader,
    customHtmlCode: CustomHtmlCode,
    patioBreadcrumbs: PatioBreadcrumbs,
    productCreator: ProductCreator,
    productFindBySize: ProductFindBySize,
    breadcrumbs: Breadcrumbs,
    categoryGrid: CategoryGrid,
    tabs: Tabs,
    accordionProductLayout: AccordionProductLayout,
    cta: CTA,
};

const Module = ({ moduleData, type }) => {
    const RequestedModule = _module2Component[type];
    // eslint-disable-next-line id-length
    const { id, verticalSpace } = moduleData?.moduleSettings ?? {};
    if (RequestedModule) {
        return (
            <section className={verticalSpace ? verticalSpacing(verticalSpace) : null} id={id}>
                <RequestedModule data={moduleData} />
            </section>
        );
    }

    return (
        <div />
    );
};

export default Module;
